import { getUnixTime, toDate } from '@lingoda/dates';
import { SortDirection, getDirection } from '@lingoda/utils';

export const sortByStartDate =
    (sortDirection = SortDirection.ASC) =>
    <T extends Readonly<{ startDate: Date | string }>>(a: T, b: T) =>
        (getUnixTime(toDate(a.startDate)) - getUnixTime(toDate(b.startDate))) *
        getDirection(sortDirection);
